@for (segment of barChartSegments; track segment.key; let index = $index) {
    <div class="dex-tranche-compos-bar_segment -color-{{index + 1}}"
         [style]="'--size:' + segment.percent + '%'">
    </div>
}
